import { useRef } from "react";
import { useParams } from "react-router-dom";
import { IconSvg } from "../../../../utils/constants/icons/iconSvg.constant";
import { useArticleSections } from "../../../../hooks/useArticleSections";
import { useSidebarIndicator } from "../../../../hooks/useSidebarIndicator";
import { formatDateToBlogView } from "../../../BlogPage/components/BlogCard/BlogCard";
import "./Article.scss";
import "./revert-normalize.scss";

export const Article = ({ article }) => {
  const { lang } = useParams();
  const ref = useRef(null);
  const sidebarRef = useRef(null);

  const items = useArticleSections(ref, article?.articleBody);

  useSidebarIndicator(items);

  return (
    <div className="article">
        <div className="article__wrapper">
          <div className="article__container">
            <h1>{article.title}</h1>
            <div className="article__aditional-info">
              <div className="article__date">
                <IconSvg tag="datePicker"/>
                <span>{formatDateToBlogView(lang, article.createdDate)}</span>
              </div>
              <div className="article__views">
                <IconSvg tag="eye"/>
                <span>{article.countOfViews}</span>
              </div>
            </div>
            <div ref={ref} className="article__body" dangerouslySetInnerHTML={{ __html: article?.articleBody || "" }}></div>
          </div>
          <div className="article__sidebar">
            {!!items?.length && <div className="article__sidebar-head">{lang === "en" ? "Contents" : "Содержание"}</div>}
            <ul className="article__sidebar-list" ref={sidebarRef}>
              {items.map((item) => (
                <li key={item.link} className="article__sidebar-item">
                  <a
                    href={item.link}
                    data-intersectionlkey={item.link}
                    className="article__sidebar-link"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <span className="article__sidebar-indicator"/>
            </ul>
          </div>
        </div>
        <div className="acrticle__recent"></div>
    </div>
  );
};
